<template>
  <v-row class="my-0 mb-5">
    <v-col class="py-0">
      <HeadingBox icon="mdi-bell" title="Indkaldelse" :loading="logsLoading">
        <v-alert v-if="!logsLoading && (visitItem['callUpStatus'] === 1 || visitItem['callUpStatus'] === 2 || visitItem['callUpStatus'] === 4)" dense text border="left" type="info" :color="callupStatusColor">{{ callupStatusText }}</v-alert>
        <template v-if="logList.length > 0">
          <div v-for="logItem in logList" class="mb-2 d-flex flex-wrap align-center">
            <v-tooltip bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20" class="mr-2">{{ typeIcon(logItem['incallType']) }}</v-icon>
              </template>
              <span>{{ typeText(logItem['incallType']) }}</span>
            </v-tooltip>
            <v-tooltip bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20" :class="['mr-4', logStatusIconColor(logItem['callUpStatus'])]">{{ logStatusIconName(logItem['callUpStatus']) }}</v-icon>
              </template>
              <span>{{ logStatusText(logItem['callUpStatus']) }}</span>
            </v-tooltip>
            <span class="text-body-1 mr-4 text-no-wrap">{{ formattedDate(logItem['incallDate']) }}</span>
            <v-tooltip v-if="logItem['pdfFileName']" bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click.prevent="downloadIncallLogPdf(logItem['visitLogId'])">
                  <v-icon size="22">icon-pdf</v-icon>
                </v-btn>
              </template>
              <span>Download</span>
            </v-tooltip>
            <v-tooltip v-if="logItem['incallContent']" bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="openPreviewDialog(logItem['incallContent'])">
                  <v-icon size="20">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Forhåndsvisning</span>
            </v-tooltip>
            <EboksAttachment
              v-for="attachment in (logItem['eboksMessageAttachments'] || [])"
              :key="`callup-logs-${logItem['visitLogId']}-${attachment['id']}`"
              :visit-id="visitItem.id"
              :attachment-id="attachment['id']"
              :attachment-type="attachment['type']"
            />
          </div>
        </template>
        <span v-if="logList.length === 0" class="text-body-1 grey--text">Ingen data...</span>
      </HeadingBox>
      <v-dialog v-model="previewDialog" width="700" overlay-color="#fff" :overlay-opacity="0.7" @click:outside="closePreviewDialog">
        <v-card>
          <v-card-text class="py-4">
            <div v-html="previewDialogContent" class="pa-3 rounded" style="white-space: pre-line;background-color: rgba(0, 0, 0, 0.05);font-size: 12px; line-height: 2; font-family: monospace, monospace;"/>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="black darken-1" text @click="previewDialog = false; closePreviewDialog()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import methods from '../../utils/methods';
  import api from '../../api/api';
  import HeadingBox from '../common/HeadingBox';
  import EboksAttachment from '@/components/common/EboksAttachment.vue';
  import logStatusIconMixin from '@/mixins/logStatusIconMixin';

  export default {
    name: 'CallUpLogs',
    components: {HeadingBox, EboksAttachment},
    mixins: [logStatusIconMixin],
    props: {
      visitItem: {
        type: Object,
      },
    },

    data: function () {
      return {
        logsLoading: false,
        logList: [],
        previewDialog: false,
        previewDialogContent: null
      };
    },

    mounted: function () {
      this.getIncallLogs();
    },

    computed: {
      callupStatusColor: function () {
        switch (this.visitItem['callUpStatus']) {
          case 2:
            return 'deep-orange accent-4';
          case 4:
            return 'deep-orange accent-4';
          default:
            return 'grey darken-2';
        }
      },
      callupStatusText: function () {
        switch (this.visitItem['callUpStatus']) {
          case 2:
            return 'Nogle incalls har fejl.';
          case 4:
            return 'Indkald ikke mulig pga. hemlig adresse.';
          default:
            return 'Indkaldsbrev er planlagt.';
        }
      },
    },

    methods: {
      openPreviewDialog: function (value) {
        this.previewDialogContent = value;
        this.previewDialog = true;
      },
      closePreviewDialog: function () {
        this.previewDialog = false;
        setTimeout(() => {
          this.previewDialogContent = null;
        }, 100);
      },
      downloadIncallLogPdf: function (visitLogId) {
        methods.downloadURL(api.incallLogsFileUrl(visitLogId));
      },
      getIncallLogs: async function () {
        this.logsLoading = true;
        let logsData = await api.getIncallLogs(this.visitItem.id);
        setTimeout(() => {
          this.setIncallList(logsData);
          this.logsLoading = false;
        }, 500);
      },
      formattedDate: function (value) {
        if (value) {
          return`${methods.getDateFromIso(value)}, ${methods.getTimeFromIso(value)}`;
        }
        return 'Afsendelse planlagt..';
      },
      setIncallList: function (data) {
        this.logList = data.data;
      },
      typeIcon: function (type) {
        let names = {
          0: 'mdi-at',
          1: 'mdi-email',
          2: 'mdi-message-text',
          3: 'mdi-alpha-e-box'
        };
        return names[type];
      },
      typeText: function (type) {
        let text = {
          0: 'Email',
          1: 'Brev',
          2: 'SMS',
          3: 'e-Boks'
        };
        return text[type];
      },
    },
  };
</script>
